import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "core-swiper",
      class: {
        "core-swiper--ready": _setup.isReady,
        "core-swiper--has-placeholder": _setup.hasPlaceholder,
      },
      style: _setup.placeholderStyle,
    },
    [
      _vm.hasNavigation
        ? _c(
            VBtn,
            {
              ref: "prevButtonRef",
              staticClass:
                "swiper-button-prev elevation-1 bg-gray-0 pa-2 rounded-circle",
              attrs: { icon: "" },
            },
            [_c("span", { staticClass: "ui-icon-arrow-left" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNavigation
        ? _c(
            VBtn,
            {
              ref: "nextButtonRef",
              staticClass:
                "swiper-button-next elevation-1 bg-gray-0 pa-2 rounded-circle",
              attrs: { icon: "" },
            },
            [_c("span", { staticClass: "ui-icon-arrow-right" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "containerRef",
          staticClass: "swiper-container",
          class: {
            "swiper-container--no-pagination": !_setup.showPagination,
            "swiper-container--slides-auto": _vm.slidesPerView === "auto",
          },
        },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            [
              _vm._t("slides", null, {
                slideAttrs: { class: "swiper-slide" },
                swiperInstance: _setup.swiperInstance,
              }),
            ],
            2
          ),
          _vm._v(" "),
          _setup.showPagination
            ? _c("div", {
                ref: "paginationRef",
                staticClass: "swiper-pagination mt-4",
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }